import { render } from "./catalogArticleDetail.vue?vue&type=template&id=47972bb8&scoped=true"
import script from "./catalogArticleDetail.vue?vue&type=script&lang=js"
export * from "./catalogArticleDetail.vue?vue&type=script&lang=js"

import "./catalogArticleDetail.vue?vue&type=style&index=0&id=47972bb8&lang=scss&scoped=true"
import "./catalogArticleDetail.vue?vue&type=style&index=1&id=47972bb8&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47972bb8"]])

export default __exports__